import type { PartyRef } from "@delta/shared";
import type { T } from "../i18n";

/** An invoice's customer or supplier as shown, or "Walk-in customer" for a walk-in POS sale or refund (W-9). */
export const partyName = (t: T, p: Pick<PartyRef, "name"> | null) => (p ? p.name : t("walkInCustomer"));
